export interface Manager2025Finish {
  id: string;
  name: string;
  emoji: string;
  place: number;
  badge: string;
  wins: number;
  losses: number;
  winPct: number;
  initialBudget: number;
  budgetSpent: number;
  budgetLeft: number;
  costPerWin: number;
  teams: Array<{
    abbr: string;
    name: string;
    price: number;
    record: string;
    wins: number;
    losses: number;
    costPerWin: number;
    verdict: string;
  }>;
  keyStoryline: string;
}

export interface Season2025RecapData {
  year: number;
  champion: {
    id: string;
    name: string;
    wins: number;
    losses: number;
    summary: string;
  };
  runnerUp: {
    id: string;
    name: string;
    wins: number;
    losses: number;
    summary: string;
  };
  totalGames: number;
  standings: Manager2025Finish[];
  topBargains: Array<{
    team: string;
    teamName: string;
    manager: string;
    price: number;
    wins: number;
    costPerWin: number;
    highlight: string;
  }>;
  notableTakeaways: string[];
}

export const SEASON_2025_RECAP: Season2025RecapData = {
  year: 2025,
  champion: {
    id: 'david',
    name: 'David',
    wins: 71,
    losses: 65,
    summary: 'Crowned 2025 Fantasy Auction Champion with 71 wins, winning on pure draft value snipes (WSH 12W @ $3, DEN 10W @ $3, BUF 13W @ $21)!',
  },
  runnerUp: {
    id: 'rob',
    name: 'Rob',
    wins: 69,
    losses: 67,
    summary: 'Finished in 2nd place just 2 wins behind David. Built a dominant ceiling behind Philadelphia (14W) and Baltimore (12W).',
  },
  totalGames: 272,
  standings: [
    {
      id: 'david',
      name: 'David',
      emoji: '🐉',
      place: 1,
      badge: '🥇 2025 CHAMPION',
      wins: 71,
      losses: 65,
      winPct: 0.522,
      initialBudget: 50,
      budgetSpent: 50,
      budgetLeft: 0,
      costPerWin: 0.70,
      keyStoryline: 'Drafted Washington for only $3 (12 wins with rookie Jayden Daniels) and Denver for $3 (10 wins). The ultimate moneyball auction masterclass.',
      teams: [
        { abbr: 'BUF', name: 'Buffalo Bills', price: 21, record: '13-4', wins: 13, losses: 4, costPerWin: 1.62, verdict: 'Anchor Contender' },
        { abbr: 'WSH', name: 'Washington Commanders', price: 3, record: '12-5', wins: 12, losses: 5, costPerWin: 0.25, verdict: '🏆 Bargain of the Year' },
        { abbr: 'LAR', name: 'Los Angeles Rams', price: 15, record: '10-7', wins: 10, losses: 7, costPerWin: 1.50, verdict: 'Solid Playoff Pick' },
        { abbr: 'DEN', name: 'Denver Broncos', price: 3, record: '10-7', wins: 10, losses: 7, costPerWin: 0.30, verdict: '💎 Elite Value Snipe' },
        { abbr: 'ATL', name: 'Atlanta Falcons', price: 4, record: '8-9', wins: 8, losses: 9, costPerWin: 0.50, verdict: 'Fair Mid-tier' },
        { abbr: 'ARI', name: 'Arizona Cardinals', price: 2, record: '8-9', wins: 8, losses: 9, costPerWin: 0.25, verdict: 'Cheap Win Factory' },
        { abbr: 'NO', name: 'New Orleans Saints', price: 1, record: '5-12', wins: 5, losses: 12, costPerWin: 0.20, verdict: '$1 Floor Filler' },
        { abbr: 'NYJ', name: 'New York Jets', price: 1, record: '5-12', wins: 5, losses: 12, costPerWin: 0.20, verdict: '$1 Floor Filler' },
      ],
    },
    {
      id: 'rob',
      name: 'Rob',
      emoji: '👑',
      place: 2,
      badge: '🥈 2ND PLACE (RUNNER-UP)',
      wins: 69,
      losses: 67,
      winPct: 0.507,
      initialBudget: 55,
      budgetSpent: 55,
      budgetLeft: 0,
      costPerWin: 0.80,
      keyStoryline: 'Rob compiled heavy hitters in Philadelphia (14W @ $14), Baltimore (12W @ $8), and LA Chargers (11W @ $7). Finished just 2 wins shy of the title.',
      teams: [
        { abbr: 'PHI', name: 'Philadelphia Eagles', price: 14, record: '14-3', wins: 14, losses: 3, costPerWin: 1.00, verdict: 'Elite Super Bowl Core' },
        { abbr: 'BAL', name: 'Baltimore Ravens', price: 8, record: '12-5', wins: 12, losses: 5, costPerWin: 0.67, verdict: '⚡ Tremendous Value' },
        { abbr: 'LAC', name: 'Los Angeles Chargers', price: 7, record: '11-6', wins: 11, losses: 6, costPerWin: 0.64, verdict: 'Harbaugh Surge' },
        { abbr: 'TB', name: 'Tampa Bay Buccaneers', price: 12, record: '10-7', wins: 10, losses: 7, costPerWin: 1.20, verdict: 'Division Winner' },
        { abbr: 'IND', name: 'Indianapolis Colts', price: 10, record: '8-9', wins: 8, losses: 9, costPerWin: 1.25, verdict: 'Solid Mid-Tier' },
        { abbr: 'MIA', name: 'Miami Dolphins', price: 1, record: '8-9', wins: 8, losses: 9, costPerWin: 0.13, verdict: 'Bargain Steal at $1' },
        { abbr: 'NYG', name: 'New York Giants', price: 2, record: '3-14', wins: 3, losses: 14, costPerWin: 0.67, verdict: 'Injury Slump' },
        { abbr: 'TEN', name: 'Tennessee Titans', price: 1, record: '3-14', wins: 3, losses: 14, costPerWin: 0.33, verdict: '$1 Speculation' },
      ],
    },
    {
      id: 'ryan',
      name: 'Ryan',
      emoji: '⚡',
      place: 3,
      badge: '🥉 3RD PLACE',
      wins: 68,
      losses: 68,
      winPct: 0.500,
      initialBudget: 50,
      budgetSpent: 50,
      budgetLeft: 0,
      costPerWin: 0.74,
      keyStoryline: 'Ryan spent $37 of his $50 budget on Kansas City ($22, 15W) and Green Bay ($15, 11W). Deep value snipes at $2 kept him in title contention all year.',
      teams: [
        { abbr: 'KC', name: 'Kansas City Chiefs', price: 22, record: '15-2', wins: 15, losses: 2, costPerWin: 1.47, verdict: 'Best Team in NFL' },
        { abbr: 'GB', name: 'Green Bay Packers', price: 15, record: '11-6', wins: 11, losses: 6, costPerWin: 1.36, verdict: 'Top-tier NFC Playoff' },
        { abbr: 'HOU', name: 'Houston Texans', price: 2, record: '10-7', wins: 10, losses: 7, costPerWin: 0.20, verdict: '💎 Massive $2 Steal' },
        { abbr: 'SEA', name: 'Seattle Seahawks', price: 2, record: '10-7', wins: 10, losses: 7, costPerWin: 0.20, verdict: '💎 Massive $2 Steal' },
        { abbr: 'CIN', name: 'Cincinnati Bengals', price: 2, record: '9-8', wins: 9, losses: 8, costPerWin: 0.22, verdict: 'Great $2 Value' },
        { abbr: 'SF', name: 'San Francisco 49ers', price: 2, record: '6-11', wins: 6, losses: 11, costPerWin: 0.33, verdict: 'Injury Marred Season' },
        { abbr: 'LV', name: 'Las Vegas Raiders', price: 3, record: '4-13', wins: 4, losses: 13, costPerWin: 0.75, verdict: 'Rough Season' },
        { abbr: 'CLE', name: 'Cleveland Browns', price: 2, record: '3-14', wins: 3, losses: 14, costPerWin: 0.67, verdict: 'QB Carousel' },
      ],
    },
    {
      id: 'frank',
      name: 'Frank',
      emoji: '🦅',
      place: 4,
      badge: '4TH PLACE',
      wins: 64,
      losses: 72,
      winPct: 0.471,
      initialBudget: 52,
      budgetSpent: 45,
      budgetLeft: 7,
      costPerWin: 0.70,
      keyStoryline: 'Frank owned two of the most dominant 2025 teams (Detroit 15W @ $18, Minnesota 14W @ $5), but left $7 unspent in the bank while his cheaper teams struggled.',
      teams: [
        { abbr: 'DET', name: 'Detroit Lions', price: 18, record: '15-2', wins: 15, losses: 2, costPerWin: 1.20, verdict: 'Dominant NFC Favorite' },
        { abbr: 'MIN', name: 'Minnesota Vikings', price: 5, record: '14-3', wins: 14, losses: 3, costPerWin: 0.36, verdict: '💎 Huge $5 Bargain' },
        { abbr: 'PIT', name: 'Pittsburgh Steelers', price: 4, record: '10-7', wins: 10, losses: 7, costPerWin: 0.40, verdict: 'Classic Tomlin Floor' },
        { abbr: 'DAL', name: 'Dallas Cowboys', price: 2, record: '7-10', wins: 7, losses: 10, costPerWin: 0.29, verdict: 'Injury Regression' },
        { abbr: 'CHI', name: 'Chicago Bears', price: 4, record: '5-12', wins: 5, losses: 12, costPerWin: 0.80, verdict: 'Rookie Growing Pains' },
        { abbr: 'CAR', name: 'Carolina Panthers', price: 3, record: '5-12', wins: 5, losses: 12, costPerWin: 0.60, verdict: 'Rebuilding Unit' },
        { abbr: 'NE', name: 'New England Patriots', price: 5, record: '4-13', wins: 4, losses: 13, costPerWin: 1.25, verdict: 'Overpay for 4 Wins' },
        { abbr: 'JAX', name: 'Jacksonville Jaguars', price: 4, record: '4-13', wins: 4, losses: 13, costPerWin: 1.00, verdict: 'Tough Campaign' },
      ],
    },
  ],
  topBargains: [
    {
      team: 'WSH',
      teamName: 'Washington Commanders',
      manager: 'David',
      price: 3,
      wins: 12,
      costPerWin: 0.25,
      highlight: 'Jayden Daniels led Washington to 12 wins for just $3 (won the title for David).',
    },
    {
      team: 'MIN',
      teamName: 'Minnesota Vikings',
      manager: 'Frank',
      price: 5,
      wins: 14,
      costPerWin: 0.36,
      highlight: 'Brian Flores defense & Justin Jefferson produced 14 wins for just $5.',
    },
    {
      team: 'HOU',
      teamName: 'Houston Texans',
      manager: 'Ryan',
      price: 2,
      wins: 10,
      costPerWin: 0.20,
      highlight: 'C.J. Stroud won the AFC South (10 wins) for only $2.',
    },
    {
      team: 'DEN',
      teamName: 'Denver Broncos',
      manager: 'David',
      price: 3,
      wins: 10,
      costPerWin: 0.30,
      highlight: 'Sean Payton\'s squad produced 10 wins at $3.',
    },
    {
      team: 'BAL',
      teamName: 'Baltimore Ravens',
      manager: 'Rob',
      price: 8,
      wins: 12,
      costPerWin: 0.67,
      highlight: 'Lamar Jackson + Derrick Henry gave Rob 12 wins for only $8.',
    },
    {
      team: 'PHI',
      teamName: 'Philadelphia Eagles',
      manager: 'Rob',
      price: 14,
      wins: 14,
      costPerWin: 1.00,
      highlight: 'Saquon Barkley and Jalen Hurts delivered 14 wins for Rob.',
    },
  ],
  notableTakeaways: [
    'Leave No Dollar Behind: Frank left $7 unspent in his bank account; if he had outbid David on Washington or Denver, he would have won the league.',
    'Stars + Scrubs vs. Balanced Depth: David won by spreading his cash on $3-$4 sleepers while keeping $21 for Buffalo.',
    'Rob was just 2 wins away: If the Giants or Titans had won 2 more games, Commissioner Rob would have hoisted the trophy.',
    '2026 AI Lesson: Do NOT let high-upside sleepers go for $2-$3 uncontested. Use Rob\'s Special AI Engine to price-enforce!',
  ],
};

/** Exact 2025 Draft Picks for all 32 teams */
export const HISTORIC_2025_SALES: Record<string, { price: number; winner: string; winnerId: string; round: number }> = {
  BUF: { price: 21, winner: 'David', winnerId: 'david', round: 1 },
  MIN: { price: 5, winner: 'Frank', winnerId: 'frank', round: 2 },
  KC: { price: 22, winner: 'Ryan', winnerId: 'ryan', round: 3 },
  DET: { price: 18, winner: 'Frank', winnerId: 'frank', round: 4 },
  GB: { price: 15, winner: 'Ryan', winnerId: 'ryan', round: 5 },
  LAR: { price: 15, winner: 'David', winnerId: 'david', round: 6 },
  DAL: { price: 2, winner: 'Frank', winnerId: 'frank', round: 7 },
  BAL: { price: 8, winner: 'Rob', winnerId: 'rob', round: 8 },
  LAC: { price: 7, winner: 'Rob', winnerId: 'rob', round: 9 },
  TB: { price: 12, winner: 'Rob', winnerId: 'rob', round: 10 },
  ATL: { price: 4, winner: 'David', winnerId: 'david', round: 11 },
  PHI: { price: 14, winner: 'Rob', winnerId: 'rob', round: 12 },
  NE: { price: 5, winner: 'Frank', winnerId: 'frank', round: 13 },
  CHI: { price: 4, winner: 'Frank', winnerId: 'frank', round: 14 },
  JAX: { price: 4, winner: 'Frank', winnerId: 'frank', round: 15 },
  PIT: { price: 4, winner: 'Frank', winnerId: 'frank', round: 16 },
  IND: { price: 10, winner: 'Rob', winnerId: 'rob', round: 17 },
  CAR: { price: 3, winner: 'Frank', winnerId: 'frank', round: 18 },
  ARI: { price: 2, winner: 'David', winnerId: 'david', round: 19 },
  DEN: { price: 3, winner: 'David', winnerId: 'david', round: 20 },
  WSH: { price: 3, winner: 'David', winnerId: 'david', round: 21 },
  SF: { price: 2, winner: 'Ryan', winnerId: 'ryan', round: 22 },
  NYG: { price: 2, winner: 'Rob', winnerId: 'rob', round: 23 },
  HOU: { price: 2, winner: 'Ryan', winnerId: 'ryan', round: 24 },
  SEA: { price: 2, winner: 'Ryan', winnerId: 'ryan', round: 25 },
  MIA: { price: 1, winner: 'Rob', winnerId: 'rob', round: 26 },
  CIN: { price: 2, winner: 'Ryan', winnerId: 'ryan', round: 27 },
  CLE: { price: 2, winner: 'Ryan', winnerId: 'ryan', round: 28 },
  LV: { price: 3, winner: 'Ryan', winnerId: 'ryan', round: 29 },
  NO: { price: 1, winner: 'David', winnerId: 'david', round: 30 },
  TEN: { price: 1, winner: 'Rob', winnerId: 'rob', round: 31 },
  NYJ: { price: 1, winner: 'David', winnerId: 'david', round: 32 },
};
